<template>
    <div>
      <img class="imgs" src="../../assets/20230928-191457.jpg" alt="">
    </div>
  </template>
  <script>
  export default {
    name: "App",
    components: {
    },
    data() {
      return {
      };
    },
    created() {},
    mounted() {
    },
    methods: {
    },
  };
  
  </script>
  
  <style>
  * {
    margin: 0;
    padding: 0;
  }
  </style>